export default __webpack_public_path__ + "static/media/circle-sketch.cd838c95.png";